import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";
import { Search } from "lucide-react";
import { ComponentProps } from "react";

import Input from "../Input/Input";

type Props = Omit<ComponentProps<typeof Input>, "icon" | "type">;

/**
 * Input preconfigured for search: the magnifier, the search input type and a
 * translated default placeholder. Everything else — sizes, the clear button,
 * `loading`, `hint` — is Input's, so a search field and a form field stay the
 * same control rather than drifting apart.
 *
 * Escape is deliberately not handled here. What it should do belongs to the
 * host: clear the field in a toolbar, close the surface in a panel.
 */
export const SearchBar = ({ placeholder, className, ...props }: Props) => {
  const { t } = useTranslation();
  return (
    <Input
      {...props}
      type="search"
      icon={<Search className="size-4" />}
      placeholder={placeholder ?? t("search")}
      // type=search draws its own clear control in WebKit, next to ours.
      className={cn(
        "[&::-webkit-search-cancel-button]:appearance-none",
        className,
      )}
    />
  );
};
